import { TrackEventFunction } from '../analytics-context-types';

export const trackEvent = ({
  tagType,
  trackType,
  options,
  params: { dataLayerAvailable, buildTag, debug, track },
  keysToDelete = ['messages', 'modal.messages'],
}: TrackEventFunction) => {
  if (dataLayerAvailable) {
    const tag = buildTag(tagType, options, keysToDelete);
    if (debug) {
      // eslint-disable-next-line no-console
      console.log(`tagType: ${tagType}`, {
        level2: tag.modal?.level2,
        events: tag.modal?.event?.map(({ eventInfo }) => ({
          eventName: eventInfo.eventName,
          eventAction: eventInfo.eventAction,
        })),
      });
    }
    track(trackType);
  }
};
